import { initWaferInteractive } from './modules/wafer-interactive.js';

(function () {
  // 初始化晶圓互動效果
  document.addEventListener('DOMContentLoaded', () => {
    initWaferInteractive();
  });
})();
